var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"school-tour"}},[_c('p',[_vm._v("We will contact you to schedule a tour.\n  Please answer the remaining questions to help us tailor your tour.")]),_c('page-controls',{attrs:{"path":"/academic-interests/0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }